import { FC, HTMLAttributes } from 'react';
import classNames from 'classnames';
import './input-grid.scss';

export interface InputGridProps extends HTMLAttributes<HTMLDivElement> {}

export const InputGrid: FC<InputGridProps> = ({ className, ...props }) => (
  <div className={classNames('input-grid grid grid-cols-12 gap-3 sm:gap-4 my-4', className)} {...props} />
);
